import React from 'react';
import '../styles/landing.css';

export const LandingPage: React.FC = () => {
    return (
        <div className="landing-container">
            {/* Ambient Background - Blobs removed for cleaner background image visibility */}

            <div className="heartbeat-container">
                <div className="glass-box">

                    <div className="ekg-container">
                        <div className="ekg-line">
                            <div className="ekg-blip" />
                        </div>
                        <div className="pulse-center" />
                    </div>

                    <h1 className="title-gradient">US Link CN</h1>

                    <div style={{
                        marginTop: '1rem',
                        fontSize: '0.9rem',
                        color: 'rgba(255,255,255,0.6)',
                        letterSpacing: '0.1em',
                        textTransform: 'uppercase',
                        fontWeight: 500
                    }}>
                        仅限受邀 / Invitation Only
                    </div>
                </div>
            </div>
        </div>
    );
};
